/**
* @module mapbs.components.help.help
*/

import angular from 'angular';
import './help.scss';

const moduleHelp = angular.module('mapbsHelpModule', []);

moduleHelp.run(
    /* ngInject */ ($templateCache) => {
        $templateCache.put(
            'mapbs/help',
            require('./help.html')
        );
    }
);

/**
* @type {!angular.Component}
*/
const helpComponent = {
    controller: 'mapbsHelpController as ctrl',
    templateUrl: 'mapbs/help',
    bindings: {},
};

moduleHelp.component('mapbsHelp', helpComponent);

class HelpController {
    constructor(){

        this.helpLinks = [
            {
                title: 'Grundstückinformation',
                youtubeId: 'JpixIfl4Qws',
                description: 'Finden Sie alle wichtigen Informationen zu einem Grundstück inklusive Angabe der Eigentümerschaft direkt in MapBS.',
            },
            {
                title: 'Auswahl-Werkzeug',
                youtubeId: 'VPQFr6wyAVQ',
                description: 'Das Auswahl-Werzeug stellt verschiedene Möglichkeiten zur Verfügung, in MapBS die Daten eine Ebene abzufragen.',
            },
            {
                title: 'Kartenebenen vergleichen',
                youtubeId: 'ZSQ_BaYsFAM',
                description: 'Verschiedene Kartenebenen in MapBS dynamisch miteinander vergleichen.',
            },
            {
                title: 'Zeichnen',
                youtubeId: 'aWBa7kvNbp8',
                description: 'Mit dem Zeichnen-Tool können Formen und Texte direkt in der Karte erfasst werden.',
            },
            {
                title: 'Zeichnen mit dem Snapping-Tool',
                youtubeId: 'YgF9y2HRGxg',
                description: 'Mit dem Snapping-Tool entlang von Daten in der Karte zeichnen.',
            },
            {
                title: 'Drucken des Stadtplans',
                youtubeId: 'L7LTiZbZMZ4',
                description: 'Aktuelle Daten kostenlos und einfach als weiterverarbeitbares PDF beziehen.',
            },

        ];
    }

}

moduleHelp.controller(
    'mapbsHelpController',
    HelpController
);

export default moduleHelp;
